import type { Invoice } from './invoice.type.ts';
export interface InvoiceExtension extends Invoice {}
export class InvoiceExtension {
  // ── Computed Properties ──
  get canAddLineItems() {
    // Legacy invoices do not support line-item editing.
    return false;
  }

  get canEditLineItems() {
    // Legacy invoices do not support line-item editing.
    return false;
  }
}

const Registration = {
  kind: 'object',
  name: 'invoice',
  features: InvoiceExtension,
};
export default Registration;
